import type { CSSProperties } from "react";

const COLOURS = ["pink", "violet", "blue"] as const;

/* The soft glow behind a new chat's greeting: three blurred blobs drifting slowly.
   The one gradient outside agent avatars, and only until the first message.

   Anchored (`at`, a point in its positioned parent) with each blob's [size, left, top] from
   that point (`blobs`), it is the glow behind a call's disc (dm.css `.glow`), drifting a few
   pixels instead of across its box. */
export default function HeroGlow({ at, blobs }: { at?: CSSProperties; blobs?: [number, number, number][] }) {
  if (!blobs) {
    return (
      <div aria-hidden="true" className="hero-glow">
        <span className="hero-glow-pink" />
        <span className="hero-glow-violet" />
        <span className="hero-glow-blue" />
      </div>
    );
  }
  return (
    <div aria-hidden="true" className="hero-glow-at" style={at}>
      {blobs.map(([edge, left, top], i) => (
        <span key={COLOURS[i]} className={`hero-glow-${COLOURS[i]}`} style={{ width: edge, height: edge, left, top }} />
      ))}
    </div>
  );
}
